import { WorkstationReworkModel } from "./workstation-rework.model";

export class HourWiseReworkModel {
    totalRework: number;
    hour: number;
    workstationLevelRework: WorkstationReworkModel[];

    constructor(totalRework: number,
        hour: number,
        workstationLevelRework: WorkstationReworkModel[]) {
            this.totalRework = totalRework;
            this.hour = hour;
            this.workstationLevelRework = workstationLevelRework;
    }
}